<template >
  <div class="tittle" v-if="from !== 'baidu'&&from !== 'H5'">
    <em class="iconfont goback" @click="gotoback">&#xe618;</em>
    <span class="titname" v-if="lotidsys == '201'">竞彩足球</span>
    <span class="titname" v-if="lotidsys == '200'">竞彩篮球</span>
    <span class="titname" v-if="lotidsys == '400'">北京单场</span>
    <div class="seltime" @click="showPicker = !showPicker">
      <span class="partime">{{ showrightissue }}</span>
      <span class="iconfont select">&#xe60e;</span>
    </div>
  </div>
  <div class="baidu" @click="showPicker = !showPicker" v-if="from === 'baidu'||from === 'H5'">
    <span class="partime">{{ showrightissue }}</span>
    <span class="iconfont select">&#xe60e;</span>
  </div>
  <div
    class="tablehead"
    :class="(from === 'baidu' || from === 'H5') ? 'tableheadBD' : ''"
    v-if="lotidsys == '201'"
  >
    <span class="bianh">编号</span>
    <span class="shengpf">胜平负</span>
    <span class="rqshengpf">让球胜平负</span>
    <span class="bifen">比分</span>
    <span class="zongjinq">总进球</span>
    <span class="banquanc">半全场</span>
  </div>
  <div
    class="tablehead"
    :class="(from === 'baidu' || from === 'H5') ? 'tableheadBD' : ''"
    v-if="lotidsys == '200'"
  >
    <span class="bianh">编号</span>
    <span class="lqshengpf">胜负</span>
    <span class="lqrqshengpf">让球胜负</span>
    <span class="lqdaxiaofen">大小分</span>
    <span class="shengfencha">胜分差</span>
  </div>
  <div
    class="tablehead"
    :class="(from === 'baidu' || from === 'H5') ? 'tableheadBD' : ''"
    v-if="lotidsys == '400'"
  >
    <span class="bianh">编号</span>
    <span class="beidanrqshengpf">让球胜平负</span>
    <span class="beidanshangxiads">上下单双</span>
    <span class="beidanbanquansheng">半全胜</span>
    <span class="beidanbifen">比分</span>
    <span class="beidanzongjinq">总进球</span>
  </div>
  <div class="zw"></div>

  <div v-if="loading">
    <div class="loadding"></div>
    <div class="tip">加载中</div>
  </div>
  <div v-else>
    <template v-if="infoslist.arrays.length > 0">
      <div class="match-list" v-if="lotidsys == '201'">
        <div
          class="match-row"
          v-for="oitem in infoslist.arrays"
          :key="oitem.time"
        >
          <div class="match-row-head">
            {{
              `${oitem.time} ${oitem.league} ${oitem.host} VS ${oitem.guest} ${oitem.bifen}`
            }}
          </div>
          <div class="match-row-cont">
            <div class="cont-span">
              <span class="tops">{{ oitem.week }}</span>
              <span class="botms">{{ oitem.weeknum }}</span>
            </div>
            <div class="cont-span" v-for="sval in oitem.rowarr" :key="sval">
              <span class="tops">{{ sval.newitem }}</span>
              <span class="botms">{{ sval.newopt }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="match-list" v-if="lotidsys == '200'">
        <div
          class="match-row"
          v-for="oitem in infoslist.arrays"
          :key="oitem.time"
        >
          <div class="match-row-head">
            {{
              `${oitem.time} ${oitem.league} ${oitem.host} VS ${oitem.guest} ${oitem.bifen}`
            }}
          </div>
          <div class="match-row-cont">
            <div class="cont-span-lq">
              <span class="tops">{{ oitem.week }}</span>
              <span class="botms">{{ oitem.weeknum }}</span>
            </div>
            <div class="cont-span-lq" v-for="sval in oitem.rowarr" :key="sval">
              <span class="tops">{{ sval.newitem }}</span>
              <span class="botms">{{ sval.newopt }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="match-list" v-if="lotidsys == '400'">
        <div
          class="match-row"
          v-for="oitem in infoslist.arrays"
          :key="oitem.time"
        >
          <div class="match-row-head">
            {{
              `${oitem.time} ${oitem.league} ${oitem.host} VS ${oitem.guest} ${oitem.bifen}`
            }}
          </div>
          <div class="match-row-cont">
            <div class="cont-span-bd">
              <span class="tops">{{ oitem.week }}</span>
              <span class="botms">{{ oitem.weeknum }}</span>
            </div>
            <div class="cont-span-bd" v-for="sval in oitem.rowarr" :key="sval">
              <span class="tops">{{ sval.newitem }}</span>
              <span class="botms">{{ sval.newopt }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <empty-page :text="'当日无赛事开奖'"></empty-page>
    </template>
  </div>
  <van-popup v-model:show="showPicker" round position="bottom">
    <van-picker
      title="选择期次"
      :columns="columns"
      item-height="40"
      :default-index="oindex"
      @cancel="showPicker = false"
      @confirm="onConfirm"
    />
  </van-popup>
</template>

<script>
import { ref, reactive, getCurrentInstance, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import emptyPage from "@/components/empty-page";
export default {
  name: "Jcdetail",
  components: {
    emptyPage,
  },
  setup() {
    const baseurl =
      getCurrentInstance().appContext.config.globalProperties.axiosurl;
    const {
      params: { issue, lotid },
    } = useRoute();
    const router = useRouter();
    let from = "";
    const route = useRoute();
    if(route.query.from&&route.query.from==='baidu'){
				from = 'baidu'
			}else if(route.query.from&&route.query.from==='H5'){
				from = 'H5'
			}else{
				from = ''
			}
    let showPicker = ref(false);
    let loading = ref(true);
    let oindex = ref(0);
    let lotidsys = ref(lotid);
    let showrightissue = ref(issue);
    let rightissue = ref("");
    let infoslist = reactive({
      arrays: [],
    });
    const gotoback = () => {
      router.back();
    };
    const dateFormat = (fmt, date) => {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    };

    let columns = [];
    const onConfirm = (value) => {
      console.log(value.text);
      showPicker.value = false;
      showrightissue.value = value.text;
      getDetailjc(lotid, value.text, "");
    };

    const getDetailjc = async (lot, issue, flag) => {
      loading.value = true;
      infoslist.arrays = [];
      let type = "";
      switch (lot) {
        case "201":
          type = "1";
          break;
        case "200":
          type = "3";
          break;
        case "400":
          type = "2";
          break;
      }
      const {
        data: { data: result },
      } = await axios(
        `${baseurl}/hdTransfer/methodNormal?function=Kaijiang_datail&type=${type}&issue=${issue}&isDg=0`
      );
      console.log("xiangqing:", result);
      //showrightissue.value = rightissue.value
      //getDetailjc(lotid,rightissue.value)
      if (result.length !== 0) {
        if (result[0].stop == "0") {
          if (flag !== "") {
            var day1 = new Date();
            day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
            showrightissue.value = dateFormat("YYYY-mm-dd", day1);
            getDetailjc(lotid, showrightissue.value, "");
          } else {
            if (lot == "201") {
              result.forEach((value, index) => {
                let spData = value.sp_data.split(";"); //[1^2.001,1^2.053,3:3^24.053,6^4.145,3-0^5.125]
                let week = value.matchNo.substr(0, 2);
                let weeknum = value.matchNo.substr(2, 3);
                let newpeilarr = [];
                spData.forEach((item, index) => {
                  let newitem = "",
                    newopt = item.split("^")[1];
                  if (item.split("^")[0].indexOf(":") > -1) {
                    newitem = item.split("^")[0];
                  } else {
                    if (index == 1) {
                      if (item.split("^")[0] == "1") {
                        newitem = `平 ${value.rq}`;
                      } else if (item.split("^")[0] == "3") {
                        newitem = `胜 ${value.rq}`;
                      } else if (item.split("^")[0] == "0") {
                        newitem = `负 ${value.rq}`;
                      }
                    } else if (index == 2) {
                      newitem = item.split("^")[0];
                    } else if (index == 4) {
                      let newstr = item.split("^")[0];
                      newitem = newstr
                        .replace(/0/g, "负")
                        .replace(/1/g, "平")
                        .replace(/3/g, "胜");
                    } else if (index == 3) {
                      newitem = item.split("^")[0];
                    } else {
                      if (item.split("^")[0] == "1") {
                        newitem = "平";
                      } else if (item.split("^")[0] == "3") {
                        newitem = "胜";
                      } else if (item.split("^")[0] == "0") {
                        newitem = "负";
                      }
                    }
                  }
                  newpeilarr.push({ newitem, newopt });
                });

                let newobj = {
                  time: value.endTime.split(" ")[1],
                  league: value.shortMatchName,
                  host: value.matchHome,
                  guest: value.matchGuest,
                  bifen: value.bifen,
                  week: week,
                  weeknum: weeknum,
                  rowarr: newpeilarr,
                };
                infoslist.arrays.push(newobj);
              });
            } else if (lot == "200") {
              result.forEach((value, index) => {
                let spData = value.sp_data.split(";").reverse(); //[1^2.001,1^2.053,3:3^24.053,6^4.145,3-0^5.125]
                let week = value.matchNo.substr(0, 2);
                let weeknum = value.matchNo.substr(2, 3);
                let newpeilarr = [];
                spData = spData.map((item, index) => {
                  if (item.indexOf("|") > -1) {
                    return item.split("|")[1];
                  } else {
                    return item;
                  }
                });
                spData.forEach((item, index) => {
                  let newitem = item.split("^")[0].replace(/@/g, " "),
                    newopt = item.split("^")[1];
                  newpeilarr.push({ newitem, newopt });
                });

                let newobj = {
                  time: value.endTime.split(" ")[1]
                    ? value.endTime.split(" ")[1]
                    : "",
                  league: value.shortMatchName,
                  host: value.matchHome,
                  guest: value.matchGuest,
                  bifen: value.bifen,
                  week: week,
                  weeknum: weeknum,
                  rowarr: newpeilarr,
                };
                infoslist.arrays.push(newobj);
              });
            } else if (lot == "400") {
              result.forEach((value, index) => {
                let spData = value.sp_data.split(";"); //[1^2.001,1^2.053,3:3^24.053,6^4.145,3-0^5.125]
                let week = "";
                let weeknum = value.matchNo;
                let newpeilarr = [];
                spData.forEach((item, index) => {
                  let newitem = "",
                    newopt = item.split("^")[1];
                  if (item.split("^")[0] == "-") {
                    newitem = "-";
                  } else {
                    if (item.split("^")[0].indexOf(":") > -1) {
                      newitem = item.split("^")[0];
                    } else {
                      if (index == 0) {
                        if (item.split("^")[0] == "1") {
                          newitem = `平 ${value.rq}`;
                        } else if (item.split("^")[0] == "3") {
                          newitem = `胜 ${value.rq}`;
                        } else if (item.split("^")[0] == "0") {
                          newitem = `负 ${value.rq}`;
                        }
                      } else if (index == 2) {
                        let newstr = item.split("^")[0];
                        newitem = newstr
                          .replace(/0/g, "负")
                          .replace(/1/g, "平")
                          .replace(/3/g, "胜");
                      } else {
                        newitem = item.split("^")[0];
                      }
                    }
                  }
                  newpeilarr.push({ newitem, newopt });
                });

                let newobj = {
                  time: value.endTime.split(" ")[1],
                  league: value.shortMatchName,
                  host: value.matchHome,
                  guest: value.matchGuest,
                  bifen: value.bifen,
                  week: week,
                  weeknum: weeknum,
                  rowarr: newpeilarr,
                };
                infoslist.arrays.push(newobj);
              });
            }
          }
        } else {
          if (lot == "201") {
            result.forEach((value, index) => {
              let spData = value.sp_data.split(";"); //[1^2.001,1^2.053,3:3^24.053,6^4.145,3-0^5.125]
              let week = value.matchNo.substr(0, 2);
              let weeknum = value.matchNo.substr(2, 3);
              let newpeilarr = [];
              spData.forEach((item, index) => {
                let newitem = "",
                  newopt = item.split("^")[1];
                if (item.split("^")[0].indexOf(":") > -1) {
                  newitem = item.split("^")[0];
                } else {
                  if (index == 1) {
                    if (item.split("^")[0] == "1") {
                      newitem = `平 ${value.rq}`;
                    } else if (item.split("^")[0] == "3") {
                      newitem = `胜 ${value.rq}`;
                    } else if (item.split("^")[0] == "0") {
                      newitem = `负 ${value.rq}`;
                    }
                  } else if (index == 2) {
                    newitem = item.split("^")[0];
                  } else if (index == 4) {
                    let newstr = item.split("^")[0];
                    newitem = newstr
                      .replace(/0/g, "负")
                      .replace(/1/g, "平")
                      .replace(/3/g, "胜");
                  } else if (index == 3) {
                    newitem = item.split("^")[0];
                  } else {
                    if (item.split("^")[0] == "1") {
                      newitem = "平";
                    } else if (item.split("^")[0] == "3") {
                      newitem = "胜";
                    } else if (item.split("^")[0] == "0") {
                      newitem = "负";
                    }
                  }
                }
                newpeilarr.push({ newitem, newopt });
              });

              let newobj = {
                time: value.endTime.split(" ")[1],
                league: value.shortMatchName,
                host: value.matchHome,
                guest: value.matchGuest,
                bifen: value.bifen,
                week: week,
                weeknum: weeknum,
                rowarr: newpeilarr,
              };
              infoslist.arrays.push(newobj);
            });
          } else if (lot == "200") {
            result.forEach((value, index) => {
              let spData = value.sp_data.split(";").reverse(); //[1^2.001,1^2.053,3:3^24.053,6^4.145,3-0^5.125]
              let week = value.matchNo.substr(0, 2);
              let weeknum = value.matchNo.substr(2, 3);
              let newpeilarr = [];
              spData = spData.map((item, index) => {
                if (item.indexOf("|") > -1) {
                  return item.split("|")[1];
                } else {
                  return item;
                }
              });
              spData.forEach((item, index) => {
                let newitem = item.split("^")[0].replace(/@/g, " "),
                  newopt = item.split("^")[1];
                newpeilarr.push({ newitem, newopt });
              });

              let newobj = {
                time: value.endTime.split(" ")[1]
                  ? value.endTime.split(" ")[1]
                  : "",
                league: value.shortMatchName,
                host: value.matchHome,
                guest: value.matchGuest,
                bifen: value.bifen,
                week: week,
                weeknum: weeknum,
                rowarr: newpeilarr,
              };
              infoslist.arrays.push(newobj);
            });
          } else if (lot == "400") {
            result.forEach((value, index) => {
              let spData = value.sp_data.split(";"); //[1^2.001,1^2.053,3:3^24.053,6^4.145,3-0^5.125]
              let week = "";
              let weeknum = value.matchNo;
              let newpeilarr = [];
              spData.forEach((item, index) => {
                let newitem = "",
                  newopt = item.split("^")[1];
                if (item.split("^")[0] == "-") {
                  newitem = "-";
                } else {
                  if (item.split("^")[0].indexOf(":") > -1) {
                    newitem = item.split("^")[0];
                  } else {
                    if (index == 0) {
                      if (item.split("^")[0] == "1") {
                        newitem = `平 ${value.rq}`;
                      } else if (item.split("^")[0] == "3") {
                        newitem = `胜 ${value.rq}`;
                      } else if (item.split("^")[0] == "0") {
                        newitem = `负 ${value.rq}`;
                      }
                    } else if (index == 2) {
                      let newstr = item.split("^")[0];
                      newitem = newstr
                        .replace(/0/g, "负")
                        .replace(/1/g, "平")
                        .replace(/3/g, "胜");
                    } else {
                      newitem = item.split("^")[0];
                    }
                  }
                }
                newpeilarr.push({ newitem, newopt });
              });

              let newobj = {
                time: value.endTime.split(" ")[1],
                league: value.shortMatchName,
                host: value.matchHome,
                guest: value.matchGuest,
                bifen: value.bifen,
                week: week,
                weeknum: weeknum,
                rowarr: newpeilarr,
              };
              infoslist.arrays.push(newobj);
            });
          }
        }
      } else {
        if (flag !== "") {
          var day1 = new Date();
          day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
          showrightissue.value = dateFormat("YYYY-mm-dd", day1);
          getDetailjc(lotid, showrightissue.value, "");
        }
      }
      loading.value = false;
    };

    const getissue = async () => {
      const {
        data: { data: allist },
      } = await axios(
        `${baseurl}/hdTransfer/methodNormal?function=getIssueList&lotteryId=${lotid}`
      );
      allist.map((item, index) => {
        // if(item.state=='1'){
        // 	rightissue.value = item.issue
        // 	oindex.value = index
        // }
        if (item.issue == issue) {
          oindex.value = index;
        }
        columns.push({ text: item.issue });
      });
    };
    getissue();
    getDetailjc(lotid, issue, "first");

    return {
      gotoback,
      lotidsys,
      showPicker,
      columns,
      onConfirm,
      oindex,
      rightissue,
      showrightissue,
      infoslist,
      from,
	  loading
    };
  },
};
</script>

<style scoped="scoped">
.tip {
  text-align: center;
  font-size: 10px;
  color: #999;
  padding-top:20px;
}
.loadding {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-animation: loadding_frame 1s linear infinite alternate;
  -moz-animation: loadding_frame 1s linear infinite alternate;
  animation: loadding_frame 1s linear infinite alternate;
  margin: 46px auto 0px auto;
  transform: translateX(-12px);
  /* Not necessary- its only for layouting*/
}
@-webkit-keyframes loadding_frame {
  0% {
    background-color: rgba(166, 166, 166, 1);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 0.2),
      24px 0px 0px 0px rgba(166, 166, 166, 0.2);
  }

  25% {
    background-color: rgba(166, 166, 166, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 2),
      24px 0px 0px 0px rgba(166, 166, 166, 0.2);
  }

  75% {
    background-color: rgba(166, 166, 166, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 0.2),
      24px 0px 0px 0px rgba(166, 166, 166, 1);
  }
}

@-moz-keyframes loadding_frame {
  0% {
    background-color: rgba(166, 166, 166, 1);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 0.2),
      24px 0px 0px 0px rgba(166, 166, 166, 0.2);
  }

  25% {
    background-color: rgba(166, 166, 166, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 2),
      24px 0px 0px 0px rgba(166, 166, 166, 0.2);
  }

  75% {
    background-color: rgba(166, 166, 166, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 0.2),
      24px 0px 0px 0px rgba(166, 166, 166, 1);
  }
}

@keyframes loadding_frame {
  0% {
    background-color: rgba(166, 166, 166, 1);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 0.2),
      24px 0px 0px 0px rgba(166, 166, 166, 0.2);
  }

  25% {
    background-color: rgba(166, 166, 166, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 2),
      24px 0px 0px 0px rgba(166, 166, 166, 0.2);
  }

  75% {
    background-color: rgba(166, 166, 166, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(166, 166, 166, 0.2),
      24px 0px 0px 0px rgba(166, 166, 166, 1);
  }
}
.baidu {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 0.44rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tittle {
  position: fixed;
  background: #ffffff;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.09);
  margin-bottom: 4px;
  width: 100%;
  z-index: 99;
}
.tittle .iconfont.goback {
  width: 0.44rem;
  height: 0.44rem;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0.2rem;
  text-align: center;
  line-height: 0.44rem;
}
.tittle span.titname {
  display: block;
  width: 100%;
  height: 0.45rem;
  font-size: 0.18rem;
  line-height: 0.45rem;
  text-align: center;
  color: #333;
}
.tittle .seltime {
  width: 0.9rem;
  height: 0.18rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: 0.1rem;
  top: 0.15rem;
}
.tittle .seltime .partime {
  font-size: 0.12rem;
  color: #666;
}
.tittle .seltime .iconfont.select {
  font-size: 0.18rem;
  position: absolute;
  right: 0.1rem;
  top: -0.04rem;
}
.tablehead {
  width: 100%;
  height: 0.35rem;
  background: #f4f4f4;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0.44rem;
  padding: 0 0.05rem;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 99;
}
/* .tableheadBD{
		top: 0 !important;
	} */
.tablehead span {
  box-sizing: border-box;
  font-size: 0.13rem;
  color: #333333;
  position: relative;
  text-align: center;
  line-height: 0.35rem;
}

.tablehead span.bianh {
  width: 0.46rem;
}
.tablehead span.shengpf {
  width: 0.59rem;
}
.tablehead span.rqshengpf {
  width: 0.85rem;
}
.tablehead span.bifen {
  width: 0.46rem;
}
.tablehead span.zongjinq {
  width: 0.59rem;
}
.tablehead span.banquanc {
  width: 0.59rem;
}

.tablehead span.lqshengpf {
  width: 0.75rem;
}
.tablehead span.lqrqshengpf {
  width: 0.89rem;
}
.tablehead span.lqdaxiaofen {
  width: 0.75rem;
}
.tablehead span.shengfencha {
  width: 0.75rem;
}

.tablehead span.beidanshangxiads {
  width: 0.75rem;
}
.tablehead span.beidanrqshengpf {
  width: 0.85rem;
}
.tablehead span.beidanbifen {
  width: 0.46rem;
}
.tablehead span.beidanbanquansheng {
  width: 0.59rem;
}
.tablehead span.beidanzongjinq {
  width: 0.59rem;
}

.tablehead span:after {
  content: "";
  position: absolute;
  width: 0.01rem;
  height: 0.13rem;
  background-color: #cfcfcf;
  right: 0;
  top: 0.1rem;
}
.tablehead span:last-child::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  background-color: #f4f4f4;
  right: 0;
}

.zw {
  height: 0.8rem;
}
.match-list {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.match-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 0.01rem solid #f4f4f4;
  padding-bottom: 0.12rem;
  box-sizing: border-box;
}
/* .match-list .match-row:first-child{margin-top:.8rem;} */
.match-row-head {
  font-size: 0.13rem;
  color: #999999;
  line-height: 0.45rem;
}
.match-row-cont {
  font-size: 0.13rem;
  display: flex;
  flex-direction: row;
}

.match-row-cont .cont-span {
  box-sizing: border-box;
  font-size: 0.13rem;
  color: #333333;
  position: relative;
  text-align: center;
  height: 0.38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.match-row-cont .cont-span:after {
  content: "";
  position: absolute;
  width: 0.01rem;
  height: 0.38rem;
  background-color: #cfcfcf;
  right: 0;
  top: 0;
}
.match-row-cont .cont-span:last-child::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  background-color: #f4f4f4;
  right: 0;
}

.match-row-cont .cont-span:first-child {
  width: 0.46rem;
}
.match-row-cont .cont-span:nth-child(2) {
  width: 0.59rem;
}
.match-row-cont .cont-span:nth-child(3) {
  width: 0.85rem;
}
.match-row-cont .cont-span:nth-child(4) {
  width: 0.46rem;
}
.match-row-cont .cont-span:nth-child(5) {
  width: 0.59rem;
}
.match-row-cont .cont-span:nth-child(6) {
  width: 0.59rem;
}

.match-row-cont .cont-span-lq {
  box-sizing: border-box;
  font-size: 0.13rem;
  color: #333333;
  position: relative;
  text-align: center;
  height: 0.38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.match-row-cont .cont-span-lq:after {
  content: "";
  position: absolute;
  width: 0.01rem;
  height: 0.38rem;
  background-color: #cfcfcf;
  right: 0;
  top: 0;
}
.match-row-cont .cont-span-lq:last-child::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  background-color: #f4f4f4;
  right: 0;
}

.match-row-cont .cont-span-lq:first-child {
  width: 0.46rem;
}
.match-row-cont .cont-span-lq:nth-child(2) {
  width: 0.75rem;
}
.match-row-cont .cont-span-lq:nth-child(3) {
  width: 0.89rem;
}
.match-row-cont .cont-span-lq:nth-child(4) {
  width: 0.75rem;
}
.match-row-cont .cont-span-lq:nth-child(5) {
  width: 0.75rem;
}

.match-row-cont .cont-span-bd {
  box-sizing: border-box;
  font-size: 0.13rem;
  color: #333333;
  position: relative;
  text-align: center;
  height: 0.38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.match-row-cont .cont-span-bd:after {
  content: "";
  position: absolute;
  width: 0.01rem;
  height: 0.38rem;
  background-color: #cfcfcf;
  right: 0;
  top: 0;
}
.match-row-cont .cont-span-bd:last-child::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  background-color: #f4f4f4;
  right: 0;
}

.match-row-cont .cont-span-bd:first-child {
  width: 0.46rem;
  justify-content: center;
}
.match-row-cont .cont-span-bd:nth-child(2) {
  width: 0.85rem;
}
.match-row-cont .cont-span-bd:nth-child(3) {
  width: 0.75rem;
}
.match-row-cont .cont-span-bd:nth-child(4) {
  width: 0.59rem;
}
.match-row-cont .cont-span-bd:nth-child(5) {
  width: 0.46rem;
}
.match-row-cont .cont-span-bd:nth-child(6) {
  width: 0.59rem;
}
</style>
